<div class="dialog-header">
  <h2 class="dialog-title" mat-dialog-title>
    {{ "Manage Favourites" | translate }}
  </h2>
  <button
    (click)="dialogRef.close()"
    mat-mini-fab
    color="warn"
    class="close-icon"
  >
    <mat-icon>close</mat-icon>
  </button>
</div>
<mat-dialog-content>
  <div class="market-wrapper">
    <div class="find-market">
      <h2 class="find-market-title text-dark">
        {{ "Find a Market" | translate }}
      </h2>
      <span class="find-market-desc"
        >{{ "Select" | translate }}
        <mat-icon>star</mat-icon>
        {{ "to add to Favourites" | translate }}</span
      >
      <div class="find-market-content">
        <ul class="markets-list list-unstyled">
          <li>
            <a class="nav-link" (click)="fetchSports()">{{
              "All Sports" | translate
            }}</a>
          </li>
          @for (parent of parents; track $index) {
            <li>
              <a
                [ngClass]="
                  isImmediateParent($index)
                    ? ['f-w-700', 'text-dark']
                    : 'text-dark'
                "
                class="nav-link"
                (click)="fetchNavItems(parent.type, parent.id)"
              >
                {{ parent?.name }}
              </a>
            </li>
          }
          @for (item of marketItems; track item) {
            <li>
              <a
                (click)="fetchNavItems(item.type, item.id)"
                [ngStyle]="{ 'font-weight': item.type === 'MARKET' }"
                class="nav-link"
              >
                {{ item?.name }}
                @if (["MARKET", "EVENT", "RACE"].includes(item?.type)) {
                  <mat-icon
                    (click)="handleFavorites(item, $event)"
                    [ngStyle]="{
                      color: !isFavorite(item) ? '#aaa' : '',
                    }"
                    [color]="isFavorite(item) ? 'primary' : ''"
                    >star</mat-icon
                  >
                }
              </a>
            </li>
          }
        </ul>
      </div>
    </div>
    <div class="my-markets">
      <h2 class="my-markets-title text-dark">{{ "My Markets" | translate }}</h2>
      <span class="my-markets-desc">{{ "Drag to reorder" | translate }}</span>
      <div
        cdkDropList
        (cdkDropListDropped)="drop($event)"
        class="my-markets-content"
      >
        @for (item of selectedItems; track item) {
          <div class="parent" cdkDrag>
            <div class="p-top">
              <div class="draggable">
                <mat-icon>drag_indicator</mat-icon>
                <span>{{ item?.name }}</span>
              </div>
              <mat-icon
                class="remove-icon"
                (click)="favoritesService.remove(item, item.type)"
                >close</mat-icon
              >
            </div>
            <div class="children">
              @for (market of item.markets; track market) {
                <div class="child">
                  <span>{{ market?.name }}</span>
                  <mat-icon
                    class="remove-icon"
                    (click)="favoritesService.remove(market, market.type)"
                    >close</mat-icon
                  >
                </div>
              }
            </div>
          </div>
        }
        @if (selectedItems.length === 0) {
          <div class="empty-notice">
            {{ "Select" | translate }}&nbsp;<mat-icon>star</mat-icon>&nbsp;{{
              "to add to Favourites" | translate
            }}
          </div>
        }
      </div>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    [disabled]="selectedItems.length === 0"
    color="warn"
    (click)="favoritesService.removeAll()"
    mat-flat-button
  >
    {{ "Remove All" | translate }}
  </button>
</mat-dialog-actions>
